/**
 * External dependencies
 */
import React, { memo } from 'react';

function Reload(): React.ReactElement {
  /* Main */
  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>網頁環境變數載入失敗，請重新整理網頁</div>
  );
}

export default memo(Reload);
